import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import about from '../assests/img/promo-bg-1.png';
import img1 from '../assests/img/promo-bg-2.jpg';
import img2 from '../assests/img/promo-bg-3.jpg';
import img3 from '../assests/img/promo-bg-4.png';

const promos = [
  {
    title: 'Samsung QLED 4K Smart TV',
    note: 'Free Shipping on orders over $89',
    image: about,
    color: '#9ee872',
  },
  {
    title: 'Sony Bravia 55" Heater',
    note: 'Free Shipping on orders over $150',
    image: img1,
    color: '#ffeb69',
  },
  {
    title: 'iPhone 18 Pro Max Plus',
    note: 'Free Shipping on orders over $250',
    image: img2,
    color: '#ffd6ef',
  },
  {
    title: 'Samsung Smart Oven',
    note: 'Free Shipping on orders over $120',
    image: img3,
    color: '#92bdf5',
  },
];

function Showact() {
  return (
    <section className="promo-products-section">
      <div className="container">
        <div className="promo-products-grid">
          {promos.map(promo => (
            <article
              className="promo-product-card"
              key={promo.title}
              style={{ backgroundImage: `url(${promo.image})` }}
            >
              <div className="promo-product-content" style={{ backgroundColor: promo.color }}>
                <span className="promo-product-badge">Enjoy 20% savings</span>
                <h4>{promo.title}</h4>
                <p>{promo.note}</p>
                <Link className="promo-product-link" to="/shop">
                  See More Products
                  <span>
                    <FiArrowUpRight />
                  </span>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Showact;
